<div class="mb-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 relative">
    <div class="surface-elevated p-5" style="opacity: 1; transform: none;">
        <div class="mb-3 flex items-center justify-between">
            <div class="flex h-12 w-12 items-center justify-center rounded-xl border border-border-primary bg-primary-soft">
                <i class="fas fa-users text-lg text-primary"></i>
            </div>
        </div>
        <div class="mb-1 text-3xl font-bold text-text-primary">{{ totalExperts }}</div>
        <div class="caption uppercase">{{ 'experts.stats.totalExperts' | translate }}</div>
    </div>

    <div class="surface-elevated p-5" style="opacity: 1; transform: none;">
        <div class="mb-3 flex items-center justify-between">
            <div class="flex h-12 w-12 items-center justify-center rounded-xl border border-warning/20 bg-warning-soft">
                <i class="fas fa-star text-lg text-warning"></i>
            </div>
        </div>
        <div class="mb-1 text-3xl font-bold text-text-primary">{{ averageRating }}</div>
        <div class="caption uppercase">{{ 'experts.stats.averageRating' | translate }}</div>
    </div>

    <div class="surface-elevated p-5" style="opacity: 1; transform: none;">
        <div class="mb-3 flex items-center justify-between">
            <div class="flex h-12 w-12 items-center justify-center rounded-xl border border-info/20 bg-info-soft">
                <i class="fas fa-award text-lg text-info"></i>
            </div>
        </div>
        <div class="mb-1 text-3xl font-bold text-text-primary">{{ totalReviews | number }}</div>
        <div class="caption uppercase">{{ 'experts.stats.totalReviews' | translate }}</div>
    </div>

    <div class="surface-elevated p-5" style="opacity: 1; transform: none;">
        <div class="mb-3 flex items-center justify-between">
            <div class="flex h-12 w-12 items-center justify-center rounded-xl border border-success/20 bg-success-soft">
                <i class="fas fa-circle-check text-lg text-success"></i>
            </div>
        </div>
        <div class="mb-1 text-3xl font-bold text-text-primary">{{ certifiedExperts }}</div>
        <div class="caption uppercase">{{ 'experts.stats.certifiedExperts' | translate }}</div>
    </div>
</div>
